import { Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private footerComponentSubject = new BehaviorSubject<Type<any> | null>(null);
  footerComponent$ = this.footerComponentSubject.asObservable();

  setFooter(component: Type<any>) {
    this.footerComponentSubject.next(component);
  }
  clearFooter() {
    this.footerComponentSubject.next(null);
  }
}
